"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegenerationEffectHandler = exports.RegenerationEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const ApplyEffect_1 = require("../../event-handlers/core/ApplyEffect");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class RegenerationEffectArgs {
    constructor(abilityKey, amountPerTurn) {
        this.abilityKey = abilityKey;
        this.amountPerTurn = amountPerTurn;
        this.__type = EffectType_1.EffectType.Regeneration;
        this.__typeName = "Regeneration";
        this.name = "Regeneration";
        this.harmful = false;
    }
}
exports.RegenerationEffectArgs = RegenerationEffectArgs;
let RegenerationEffectHandler = class RegenerationEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new ApplyEffect_1.ApplyEffectEventHandlerArgs(state.creatorId, Target_1.Target.Any([state.targetId]), Duration_1.Duration.Instant, new _1.HoTHealingEffectArgs(state.args.abilityKey, state.args.amountPerTurn, 33)));
        sequence.push(new __1.FloatingTextVfxStepArgs("+ Regen", new __1.ActorVfxLocationSelector(state.targetId, "head"), "green"));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
        sequence.push(new __1.FloatingTextVfxStepArgs("- Regen", new __1.ActorVfxLocationSelector(state.targetId, "head"), "green"));
    }
};
RegenerationEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Regeneration)
], RegenerationEffectHandler);
exports.RegenerationEffectHandler = RegenerationEffectHandler;
